import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, IconButton, Button, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { IoMdAdd } from 'react-icons/io';
import {IoMdSave } from 'react-icons/io';
import productService from '../../../../services/productService';
import { validateExcelAdd } from '../../../../utils/validation';
import { useSelector } from 'react-redux';
import useAlert from '../../../../hooks/useAlert';

const ExcelUploader = ({ onFilesChange }) => {
  const [files, setFiles] = useState([]);
  const [type, setType] = useState(1);
  const [formErrors, setFormErrors] = useState({});
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const userId = useSelector((state) => state?.auth?.user?.id);
  const { showErrorAlertExcelAdd, showSuccessAlertexcelAdd } = useAlert();
  const onDrop = (acceptedFiles) => {
    const readFiles = (file) =>
      new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve({
            file,
            name: file.name,
            base64: reader.result.split(',')[1],
          });
        };
        reader.readAsDataURL(file);
      });

    Promise.all(acceptedFiles.map(readFiles)).then((newFiles) => {
      if (files.length + newFiles.length <= 1) {
        const updatedFiles = [...files, ...newFiles];
        setFiles(updatedFiles);
        onFilesChange(updatedFiles);
      } else {
        alert('En fazla 1 dosya yükleyebilirsiniz.');
      }
    });
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: '.xlsx, .xls',
    multiple: true,
  });

  const removeFile = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
    onFilesChange(updatedFiles);
  };

  const handleChange = (event) => {
    setType(event.target.value);
  };

  const addExcel = async() => {
    const data={};
    data.userId=userId;
    data.base64=files[0].base64;
    data.type=type;
    const errors = validateExcelAdd(data);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
    try {
        await productService.addExcel(data, token);
    
        showSuccessAlertexcelAdd();
      
    }catch{
    
      showErrorAlertExcelAdd();
   
    }
  }
  };

  return (
 
<Box
  sx={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
    p: { xs: 2, sm: 3, md: 4 },
    backgroundColor: "#F7F9FC",
    borderRadius: { xs: 2, sm: 3, md: 5 },
    border: "1px solid #e0e0e0",
    width: "90%",
    maxWidth: "600px",
    mx: "auto",
    gap: 3, // <-- aralara boşluk ekledik
  }}
>
  <Typography
    variant="h6"
    sx={{
      fontWeight: 'bold',
      color: '#343089',
      textAlign: 'center',
    }}
  >
    Excel Yükleme Alanı
  </Typography>

  <Button
    {...getRootProps()}
    variant="outlined"
    startIcon={<IoMdAdd />}
    sx={{
      backgroundColor: '#fff',
      color: '#343089',
      border: '1px solid #343089',
      textTransform: 'none',
      padding: '10px 20px',
      borderRadius: '12px',
      '&:hover': {
        backgroundColor: '#f1f1f1',
        border: '1px solid #343089',
      },
    }}
  >
    <input {...getInputProps()} style={{ display: 'none' }} />
    Dosya Ekle
  </Button>

  <FormControl fullWidth>
    <InputLabel id="excel-type-label">Excel Türü</InputLabel>
    <Select
      labelId="excel-type-label"
      id="excel-type"
      value={type}
      onChange={handleChange}
      error={!!formErrors.type}
    >
      <MenuItem value={1}>Ürün yükleme</MenuItem>
      <MenuItem value={2}>Stok ve Fiyat Güncelleme</MenuItem>
    </Select>
    {formErrors.type && (
      <Typography variant="body2" color="error">
        {formErrors.type}
      </Typography>
    )}
  </FormControl>

  <Button
    onClick={addExcel}
    variant="contained"
    startIcon={<IoMdSave />}
    sx={{
      borderRadius: 18,
      backgroundColor: '#1F1B45',
      color: '#FFFFFF',
      textTransform: 'none',
      fontWeight: 500,
      fontSize: '0.875rem',
      padding: '10px 20px',
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      '&:hover': {
        backgroundColor: '#2C285A',
      },
    }}
  >
    Kaydet
  </Button>
</Box>

 
  );
};

export default ExcelUploader;
